import * as tslib_1 from "tslib";
import { HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { throwError } from 'rxjs';
import { catchError, filter, tap } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "../authentication/authentication.service";
import * as i2 from "@angular/router";
var AuthErrorInterceptor = /** @class */ (function () {
    function AuthErrorInterceptor(authenticationService, router) {
        this.authenticationService = authenticationService;
        this.router = router;
    }
    AuthErrorInterceptor.prototype.intercept = function (request, next) {
        var _this = this;
        return next.handle(request).pipe(filter(function (event) { return event instanceof HttpResponse; }), tap(function (response) {
            if (isAuthErrorStatus(response.status) || hasUnauthenticatedErrorCode(response.body)) {
                _this.logoutAndRedirect();
            }
        }), catchError(function (err) {
            if (isAuthErrorStatus(err.status) || hasUnauthenticatedErrorCode(err.error)) {
                _this.logoutAndRedirect();
            }
            return throwError(err);
        }));
    };
    AuthErrorInterceptor.prototype.logoutAndRedirect = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authenticationService.logout()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.router.navigateByUrl('/login')];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthErrorInterceptor.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthErrorInterceptor_Factory() { return new AuthErrorInterceptor(i0.ɵɵinject(i1.AuthenticationService), i0.ɵɵinject(i2.Router)); }, token: AuthErrorInterceptor, providedIn: "root" });
    return AuthErrorInterceptor;
}());
export { AuthErrorInterceptor };
function isAuthErrorStatus(status) {
    return status === 401;
}
function hasUnauthenticatedErrorCode(body) {
    return body && Array.isArray(body.errors) && body.errors
        .filter(function (error) { return error.extensions; })
        .some(function (error) { return error.extensions.code === 'UNAUTHENTICATED'; });
}
